<template>
    <div class="nav-links">
        <router-link
            class="nav-link"
            :to="{ name: 'bi-discover' }"
            @click.native="handleRouteTrackGTMEvent('bi-discover')"
        >
            What's New
        </router-link>
        <router-link
            class="nav-link"
            :to="{ name: 'bi-library' }"
            @click.native="handleRouteTrackGTMEvent('bi-library')"
        >
            Library
        </router-link>
        <router-link
            class="nav-link"
            :to="{ name: 'insight-about-us' }"
            @click.native="handleRouteTrackGTMEvent('insight-about-us')"
        >
            About
        </router-link>
    </div>
</template>

<script>
export default {
    name: "NavLinks",
    methods: {
        handleRouteTrackGTMEvent(routeName) {
            const customEvents = {
                "bi-library": {
                    event: "bi-nav-allpages-headerlibrary",
                    action: "headerlibrary"
                },
                "bi-discover": {
                    event: "bi-nav-allpages-headernew",
                    action: "headernew"
                },
                "bi-archive": {
                    event: "bi-nav-allpages-headerfeatured",
                    action: "headerfeatured"
                },
                "insight-about-us": {
                    event: "bi-nav-allpages-headerabout",
                    action: "headerabout"
                }
            };

            if (customEvents.hasOwnProperty(`${routeName}`)) {
                const gtmEvent = {
                    ...customEvents[routeName]
                };

                this.$_gtmTrackEvent(gtmEvent);
            }
        }
    }
}
</script>

<style lang="scss">
.nav-links {
    margin-right: auto;

    .nav-link {
        color: white;
        font-size: 15px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.4px;
    }
}
</style>
